import { render, staticRenderFns } from "./select-responsible-for.vue?vue&type=template&id=278f0a8a"
import script from "./select-responsible-for.vue?vue&type=script&lang=js"
export * from "./select-responsible-for.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports